import React from 'react';
import * as Yup from 'yup';
import { FormContainer } from '~/views/event-types/styles';
import { Checkbox, InputGroup } from '~/components/form';

export const EventTypeSchema = Yup.object().shape({
  name: Yup.string().min(4, 'Verifique se o nome está correto').required('Informe o nome'),
});

export const EventTypeForm = ({ errors, touched, previewMode }) => {

  return (
    <FormContainer>
      <Checkbox name='active' label='Ativo' />

      <InputGroup
        type="text"
        name="name"
        label="Nome"
        maxLength={100}
        disabled={previewMode}
        hasError={errors.name && touched.name} />

    </FormContainer>
  );
};
